// Service-tier feature entitlements (mirror of backend/entitlements.py).
// Baseline (inmate app + institution dashboard) is always on; tiers add features.

export const TIER_FEATURES = {
    core: [],
    reentry: ["prerelease"],
    care: ["clinical"],
    clinical: ["prerelease", "clinical"],
};

export const TIER_OPTIONS = [
    { value: "core", label: "Tier 1 — Baseline (inmate app + safety)" },
    { value: "reentry", label: "Tier 2 — Baseline + Pre-Release" },
    { value: "care", label: "Tier 3 — Baseline + Clinical Care" },
    { value: "clinical", label: "Tier 4 — Baseline + Pre-Release + Clinical Care (Full)" },
];

export const tierFeatures = (tier) => TIER_FEATURES[tier || "core"] || [];
export const hasFeature = (tier, feature) => tierFeatures(tier).includes(feature);
export const hasPrerelease = (tier) => hasFeature(tier, "prerelease");
export const hasClinical = (tier) => hasFeature(tier, "clinical");
// Appointments require either feature (Core/baseline has none).
export const hasAppointments = (tier) => hasPrerelease(tier) || hasClinical(tier);
// Medicaid is a separate add-on (flag from the backend), independent of tier.
export const hasMedicaid = (institution) => !!institution?.medicaid_addon;

// Encounter (note) type → required feature (null = always allowed).
export const NOTE_TYPE_FEATURE = {
    therapy_session: "prerelease",
    prerelease: "prerelease",
    initial_eval: "clinical",
    psych_followup: "clinical",
    med_management: "clinical",
    crisis_intervention: "clinical",
    medical: "clinical",
    medication_release: "clinical",
    informational: null,
    other: null,
};

export const noteTypeAllowed = (tier, encounterType) => {
    const feat = NOTE_TYPE_FEATURE[encounterType];
    return feat == null || hasFeature(tier, feat);
};
